// Turns the hand-authored links in coding-modes.yml into embed/thumbnail URLs.
// Accepts watch, youtu.be, shorts, embed and playlist links, or a bare id.

const ID_PATTERN = /^[A-Za-z0-9_-]{11}$/
// Playlist ids vary in length and prefix (PL… / OLAK… / RD…).
const PLAYLIST_PATTERN = /^[A-Za-z0-9_-]{12,}$/
const HOSTS = [
    'youtube.com',
    'm.youtube.com',
    'youtube-nocookie.com',
    'youtu.be',
]
const PATH_PREFIXES = ['embed', 'shorts', 'v', 'live']

function toUrl(input) {
    if (typeof input !== 'string' || !input.trim()) return null
    const value = input.trim()
    try {
        const url = new URL(
            value.startsWith('http') ? value : `https://${value}`
        )
        const host = url.hostname.replace(/^www\./, '')
        return HOSTS.includes(host) ? { url, host } : null
    } catch (e) {
        return null
    }
}

function parseVideoId(input) {
    if (typeof input === 'string' && ID_PATTERN.test(input.trim())) {
        return input.trim()
    }

    const parsed = toUrl(input)
    if (!parsed) return null
    const { url, host } = parsed

    if (host === 'youtu.be') {
        const id = url.pathname.split('/').filter(Boolean)[0] || ''
        return ID_PATTERN.test(id) ? id : null
    }

    const queryId = url.searchParams.get('v') || ''
    if (ID_PATTERN.test(queryId)) return queryId

    const [prefix, id] = url.pathname.split('/').filter(Boolean)
    return PATH_PREFIXES.includes(prefix) && ID_PATTERN.test(id) ? id : null
}

function parsePlaylistId(input) {
    const parsed = toUrl(input)
    const list = parsed ? parsed.url.searchParams.get('list') : null
    return list && PLAYLIST_PATTERN.test(list) ? list : null
}

// Privacy-friendly embed host, related videos limited to the same channel.
// A link carrying both a video and a playlist starts on that video with the
// rest of the playlist queued after it.
export function getYouTubeEmbedUrl(input, { autoplay = false } = {}) {
    const id = parseVideoId(input)
    const playlistId = parsePlaylistId(input)
    if (!id && !playlistId) return null

    const params = new URLSearchParams({
        rel: '0',
        modestbranding: '1',
        playsinline: '1',
    })
    if (playlistId) params.set('list', playlistId)
    if (autoplay) params.set('autoplay', '1')

    const path = id || 'videoseries'
    return `https://www.youtube-nocookie.com/embed/${path}?${params.toString()}`
}

// hqdefault exists for every video, unlike maxresdefault which 404s on older
// uploads. Null for a playlist-only link, which has no video to derive it from.
export function getYouTubeThumbnailUrl(input) {
    const id = parseVideoId(input)
    return id ? `https://i.ytimg.com/vi/${id}/hqdefault.jpg` : null
}
